import React, { Component } from "react";
import "./index.css";
import { pdf } from "@react-pdf/renderer";
import saveAs from "file-saver";

/* Components */
import OnlineCV from "./components/OnlineCV";
import DashboardSectionBase from "../../../../components/DashboardSectionBase";
import { MyDocument } from "../../../../components/CVPDF";
import { MyDocumentTwoColumn } from "../../../../components/CVPDF/twoColumn";
import CVTemplatePicker from "../../../../components/CVTemplatePicker";

/* Helpers */
import { calculatePercent } from "../../../../helpers/candidate";
import { resizeImageForPDF } from "../../../../helpers/image";

export default class CV extends Component {

    state = {
        pickerOpen: false,
        pickerBusy: false,
    };

    componentDidMount() {

        return document.getElementById("Dashboard").scrollTo(0, 0);

    }

    renderTemplate = (templateId, sections, accentColor, profileImageSrc) => {
        const user = this.props.user;
        if (templateId === "twocolumn") return <MyDocumentTwoColumn user={user} sections={sections} accentColor={accentColor} profileImageSrc={profileImageSrc} />;
        return <MyDocument user={user} sections={sections} accentColor={accentColor} profileImageSrc={profileImageSrc} />;
    };

    handlePick = async (templateId, sections, accentColor) => {

        const user = this.props.user;
        const firstName = user.firstName;
        const lastName  = user.lastName;

        this.setState({ pickerBusy: true });

        try {
            const profileImageSrc = await resizeImageForPDF(user?.profile?.profileImage);
            const document = this.renderTemplate(templateId, sections, accentColor, profileImageSrc);

            const blobPdf = pdf(document);
            blobPdf.updateContainer(document);

            const result = await blobPdf.toBlob();
            saveAs(result, `${firstName} ${lastName} Generated CV.pdf`);
            this.setState({ pickerBusy: false, pickerOpen: false });
        } catch (err) {
            this.setState({ pickerBusy: false });
        }
    };

    render() {

        const completion = calculatePercent(this.props.user.profile);

        return(
            <>
                <DashboardSectionBase title="Your J4Crew CV" subtitle="A live preview of the CV built from your profile.">
                    <div className="cv-completion-container">
                        <div className="cv-completion-header">
                            <span className="cv-completion-label">Profile completion</span>
                            <span className="cv-completion-value">{completion}%</span>
                        </div>
                        <div className="cv-completion-bar">
                            <div className="cv-completion-bar-fill" style={{ width: `${completion}%` }} />
                        </div>
                    </div>

                    <div className="cv-actions">
                        <button type="button" className="cv-action-primary" onClick={() => this.props.history.push("/profile")}>
                            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M12 20H21" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
                                <path d="M16.5 3.5A2.121 2.121 0 0 1 19.5 6.5L7 19L3 20L4 16L16.5 3.5Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span>Edit your profile</span>
                        </button>
                        <button type="button" className="cv-action-secondary" onClick={() => this.setState({ pickerOpen: true })}>
                            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2Z" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
                                <path d="M14 2V8H20" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
                                <path d="M12 12V18" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
                                <path d="M9 15L12 18L15 15" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span>Download CV…</span>
                        </button>
                    </div>

                    <div className="cv-callout">
                        <svg className="cv-callout-icon" width={20} height={20} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2Z" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
                            <path d="M14 2V8H20" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
                            <path d="M12 12V18" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
                            <path d="M9 15L12 18L15 15" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <p className="cv-callout-text">
                            <strong>This CV is yours to keep.</strong> Download a polished PDF - choose the layout, colour and sections - and use it for any job application, on J4Crew or anywhere else.
                        </p>
                    </div>
                </DashboardSectionBase>

                <DashboardSectionBase>
                    <div className="cv-preview">
                        <OnlineCV user={this.props.user} />
                    </div>
                </DashboardSectionBase>

                <CVTemplatePicker
                    show={this.state.pickerOpen}
                    busy={this.state.pickerBusy}
                    onCancel={() => this.setState({ pickerOpen: false })}
                    onConfirm={this.handlePick}
                />
            </>
        );

    }

}
